import { Card, CardBody, CardFooter, CardHeader } from "@nextui-org/react";

Card.CardBody = CardBody;
Card.CardHeader = CardHeader;
Card.CardFooter = CardFooter;

export default Card;
